import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import FormTitle from '../components/setSendData/FormTitle';
import NameAndAccountData from '../components/setSendData/NameAndAccountData';
import BasicData from '../components/setSendData/BasicData';
import CreateFields from '../components/setSendData/CreateFields';
import EmailTemplate from '../components/setSendData/EmailTemplate';
import DownloadReportModal from '../components/setSendData/DownloadReportModal';
import SendTime from '../components/setSendData/SendTime';
import EmailData from '../components/setSendData/EmailData';
import ButtonReportData from '../components/setSendData/ButtonReportData';
import ButtonSendData from '../components/setSendData/ButtonSendData';
import NoAdAccountPage from '../components/setSendData/NoAdAccountPage';

import ExcelData from '../components/setSendData/ExcelData';
import FbCampaignData from '../components/setSendData/facebook/FbCampaignData';
import FbFieldsData from '../components/setSendData/facebook/FbFieldsData';

import ModalComponent from '../components/modal/ModalComponent';
import { MODAL_CREATE_REPORT } from '../components/modal/constants';
import Loading from '../components/loading/Loading';
import { SEND_TIME_DATA, handleMailMessageExtra, handleBiweeklyStart } from '../components/setSendData/data/emailConstants';

import {
  INPUT_ERROR_MSG,
  DOWNLOAD_ERROR_MSG,
  checkExcelNaming,
  checkDateRangeForm,
  checkReportForm,
} from '../components/formData/formData';

import { BoxModalAlert } from '../components/customComponent';

import { REPORT_LANGUAGE, getManualTranslation, transformFieldsName } from '../i18n';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import { requestKey } from '../api/api';
import { apiList, getCancelData } from '../api/callAPI';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';
import useCancel from '../hook/useCancel';
import useFieldsData from '../hook/useFieldsData';
import useColorSystem from '../hook/useColorSystem';

import { excelSheets, hideRequiredFields, requiredFields } from '../utils/FbFieldsDefined';
import { formatDate, compareAscDate, handleDateRange, formatDate2, formatDate3, isValidDateRange } from '../utils/date';
import { scrollToAnchor } from '../utils/commonUtils';


const media = 'FACEBOOK';
const initIncrementIndexNumber = 4;

const FbCreateData = (props) => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath, setModalContent, setIsModalOpen, setModalData, handleAlertMsgSettings } = useGlobalStatus();
  const { cancelData, setCancelData } = useCancel();

  const [currentTab, setCurrentTab] = useState(0);
  const [cidList, setCidList] = useState([]);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState([]);
  const [isDataReady, setIsDataReady] = useState({ cidList: false, campaignList: false });

  const [reportName, setReportName] = useState('');
  const [dateRange, setDateRange] = useState({
    startSendDate: null,
    endSendDate: null
  });
  const [reportDateRange, setReportDateRange] = useState({
    startReportDate: null,
    endReportDate: null
  });
  const [reportLanguage, setReportLanguage] = useState(currentActiveData.language || REPORT_LANGUAGE.zh);
  const [sendTimeData, setSendTimeData] = useState(SEND_TIME_DATA);

  const [emailList, setEmailList] = useState([]);
  const [emailString, setEmailString] = useState();
  const [emailTemplateType, setEmailTemplateType] = useState(basicConstants.EMAIL_TEMPLATE_REACH);
  const [emailTemplatePrev, setEmailTemplatePrev] = useState({});
  const [emailTemplateCurrent, setEmailTemplateCurrent] = useState({});
  const [emailTemplateDitto, setEmailTemplateDitto] = useState(true);

  const [excelSheetSelected, setExcelSheetSelected] = useState([]);

  const [optionalFields, requiredMetricsFields, updateRequiredFields] = useFieldsData();
  const [allOptionFields, setAllOptionFields] = useState([]);
  const [selectedOptionFields, setSelectedOptionFields] = useState(entryPath.includes('create') ? requiredFields : []);
  const [updateSortFields, setUpdateSortFields] = useState([]); //已選擇的所有欄位排序

  const [origiCustomData, setOrigiCustomData] = useState([]);
  const [selectedCustomFields, setSelectedCustomFields] = useState([]);

  const [inputErrorMsg, setInputErrorMsg] = useState(INPUT_ERROR_MSG)
  const [downloadInputErrorMsg, setDownloadInputErrorMsg] = useState(DOWNLOAD_ERROR_MSG)

  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);
  const [modalName, setModalName] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [downloadOrSend, setDownloadOrSend] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const getSelectedCidData = (allCidList, selectedCidList) => {
    return _.filter(allCidList, el => _.findIndex(selectedCidList, c => c.adAccountId === el.adAccountId) > -1);
  }

  const getSelectedCampaign = (allCampaign, selectedCampaign) => {
    return _.filter(allCampaign, el => _.findIndex(selectedCampaign, c => c === el.id) > -1);
  }

  useEffect(() => {
    if (!userData) return;

    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();

    apiList.apiGetOwnedAdAccount({
      page: 0,
      size: 100000
    }, call.token)
      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

        if (res.status === 200) {
          setCidList(res.data.result.content.filter((el) => el.media === 'FACEBOOK'));
          if (entryPath === urlConstants.PAGE_FB_CREATE_DATA) {
            setSelectedAdAccounts([]);
          } else {
            setSelectedAdAccounts(getSelectedCidData(res.data.result.content, currentActiveData.facebookAccounts));
          }
          setIsDataReady(prev => ({ ...prev, cidList: true }));
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })

  }, [userData])

  useEffect(() => {
    setCampaignList([]);
    setSelectedCampaign([]);

    if (entryPath.includes('edit') && selectedAdAccounts.length > 0) {
      setIsLoading(true);
      fetchCampaignData('edit');
    }
  }, [selectedAdAccounts])

  useEffect(() => {
    if (entryPath.includes('create') && isDataReady.cidList) {
      setIsLoading(false);
    } else if (entryPath.includes('edit') && isDataReady.cidList && isDataReady.campaignList && campaignList?.length > 0) {
      setIsLoading(false);
    }
  }, [isDataReady.cidList, isDataReady.campaignList, campaignList, entryPath]);

  //重新整理後返回媒體選單
  useEffect(() => {
    if (entryPath === '') {
      history.push(urlConstants.PAGE_MEDIA_MENU);
    }
  }, [entryPath])

  //儲存寄送設定
  useEffect(() => {
    if (downloadOrSend === 'downloadData') {
      return;
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }, [downloadOrSend])

  //改變帳號時清空行銷活動、已選自訂事件
  useEffect(() => {
    setCampaignList([]);
    setSelectedCampaign([]);

    // if (entryPath.includes('create')) {
    //   const customFieldsIndex = selectedOptionFields.findIndex(el => el.type === "CUSTOM");
    //   if (customFieldsIndex > -1) {
    //     const clearSelectCustomFields = selectedOptionFields.filter(el => el.type !== "CUSTOM");
    //     setSelectedOptionFields(clearSelectCustomFields);
    //   }
    // }
  }, [selectedAdAccounts])

  //匯入廣告活動
  const fetchCampaignData = (type) => {
    setIsLoading(true);
    setSelectedCampaign([]);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);

    if (!adAccountId.length) return;

    apiList.getCampaign({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          const resData = res.data.result;
          handleCampaignData(resData, type);
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
          setIsLoading(false);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
          setIsLoading(false);
        }
      })
  }

  const handleCampaignData = (resData, type) => {
    let modalName = '';
    let listData = [];
    let selectedData = [];

    if (type === 'create') {
      setModalContent((resData === null || !resData?.length) ? { ...MODAL_CREATE_REPORT['checkNoMarketingCampaign'], media: media } : { ...MODAL_CREATE_REPORT['checkImportMarketingCampaign'], media: media });
      setIsModalOpen(true);
    }

    if (type === 'edit') {
      selectedData = getSelectedCampaign(resData, currentActiveData.campaignList);
    }

    if (resData !== null && resData.length) {
      listData = resData;
    }

    setModalName(modalName);
    setCampaignList(listData);
    setSelectedCampaign(selectedData);
    setIsDataReady(prev => ({ ...prev, campaignList: true }));
  }

  //廣告活動(回傳格式)
  const campaignData = selectedCampaign.map((edition) => {
    return {
      cid: edition.cid,
      cidname: edition.cidname,
      id: edition.id,
      name: edition.name
    }
  })

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === 'reportName') {
      setReportName(value);
    }
    if (name === 'emailString') {
      setEmailString(value);
    }
  }

  const handleModalDetail = (type) => {
    setOpenModal(true);

    if (type === 'create_custom_metric') {
      setModalName('create_custom_metric');
    }
  }

  //新增自定義指標
  const addCustomFields = (newFields, matchFields) => {
    const cloneAllOptionFields = JSON.parse(JSON.stringify(allOptionFields));
    const customFieldsIndex = _.findIndex(cloneAllOptionFields, (el) => el.category === 'custom');

    if (customFieldsIndex > -1) {
      cloneAllOptionFields[customFieldsIndex].child.push(newFields);
    } else {
      cloneAllOptionFields.unshift({
        category: 'custom',
        name: 'custom',
        child: [newFields]
      })
    }

    setAllOptionFields(cloneAllOptionFields);

    //有設公式的指標自動打勾
    cloneAllOptionFields.forEach(field => {
      field.child.forEach(el => {
        if (matchFields.includes(el.expression)) {
          if (!selectedOptionFields.some(item => item.expression === el.expression)) {
            setSelectedOptionFields(prev => [...prev, {
              ...el,
              indexNumber: prev.length + initIncrementIndexNumber
            }]);
          }
        }
      })
    })

    setSelectedOptionFields(prev => [...prev, newFields]);
  }

  const validateReportForm = (isDownload) => {
    const formData = {
      reportName,
      fbAdAccounts: selectedAdAccounts,
      excelSheet: excelSheetSelected.filter(el => el !== 'RAW_DATA'),
      selectFields: selectedOptionFields,
      optionFieldName: selectedOptionFields,
      reportType: sendTimeData,
      emailList,
      emailTemplate: emailTemplateCurrent,
      emailTemplateType,
      dateRange,
      isDownload
    };

    return checkReportForm(formData, media);
  }

  const clickDownloadReport = () => {
    setDownloadOrSend('downloadData');
    const { errorMsg, isErrorStatue } = validateReportForm(true);
    setInputErrorMsg({ ...errorMsg, reportDateRange: '' });

    if (isErrorStatue) {
      if (errorMsg.reportName || errorMsg.fbAdAccounts) {
        scrollToAnchor('scrollTop');
      }
      return;
    }

    setModalName('setting_report_dateRange');
    setModalContent({ ...MODAL_CREATE_REPORT['chooseSaveReport'], media: media });
  }

  const clickUpdateReport = () => {
    if (downloadOrSend === 'downloadData' || downloadOrSend === '') {
      setDownloadOrSend('sendData');
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }

  const prepareReportData = () => {
    const formatDateIfNotNull = date => date !== null ? formatDate(date) : null;
    const localizedFields = transformFieldsName(media,_.concat(hideRequiredFields, selectedOptionFields), reportLanguage, intl);

    return {
      "weeklyReportName": reportName,
      "startSendDate": null,
      "endSendDate": null,
      "sendDay": sendTimeData.weekday + 1,
      "sendTime": basicConstants.HOUR_LIST[sendTimeData.weektime],
      "monthly": sendTimeData.monthday + 1,
      "biweekly_day": sendTimeData.biWeekDay + 1,
      "biweekly_start": sendTimeData.biWeeklyChecked ? handleBiweeklyStart(currentActiveData, sendTimeData) : null,
      "reportType": sendTimeData.reportType.join(','),
      "facebookAdAccountIds": selectedAdAccounts.map(el => el.adAccountId),
      "toAddresses": emailList.filter(el => el !== ""),
      "mailMessageType": emailTemplateType,
      "mailMessageExtra": handleMailMessageExtra(media, emailTemplateType, emailTemplateCurrent, reportLanguage, intl),
      "excelSheets": excelSheetSelected,
      "fields": localizedFields,
      "startReportDate": formatDateIfNotNull(reportDateRange.startReportDate),
      "endReportDate": formatDateIfNotNull(reportDateRange.endReportDate),
      "campaignList": campaignData.map((el) => el.id),
      "language": reportLanguage,
    }
  }

  const handleChooseSaveReport = (saveSettings) => {
    const errorMsg = checkDateRangeForm(reportDateRange);
    setInputErrorMsg({ reportDateRange: errorMsg });
    if (errorMsg) return;

    const storeReportData = prepareReportData();

    if (saveSettings === 'saveReport') {
      handleDownloadReport(storeReportData);
    } else {
      setModalContent({ ...MODAL_CREATE_REPORT['processingDownloadReport'], media: media });
      setIsModalOpen(true);
      setModalName('');
      downloadExternalReport(storeReportData);
    }
  }

  const handleDownloadReport = (storeReportData) => {
    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  const handleStoreReport = () => {
    const { isTab1Error, isTab2Error, errorMsg, isErrorStatue } = validateReportForm(false);
    setInputErrorMsg(errorMsg);

    if (isTab1Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(0);
    } else if (isTab2Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(1);
    }

    if (isErrorStatue) return;

    const storeReportData = prepareReportData();

    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  //1.createReport 
  const createReport = (createReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.createReport(createReportData)
      .then(res => {
        if (res.status === 200) {
          if (downloadOrSend === 'downloadData') {
            getSendList();
          } else if (downloadOrSend === 'sendData') {
            setIsLoading(false);
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_FB_SEND_LIST);
            }, 2000)
          }

        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setIsLoading(false);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })

  }

  //取得寄送清單 getReportList 
  const fetchData = (cancelToken) => {
    let result;

    result = apiList.getReportList({
      page: 0,
      size: 10,
      sort: null,
      order: null
    }, cancelToken)

    result.then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

      if (res.status === 200) {
        confirmReport(res.data.result.content);
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        alert(alertConstants.ERROR_SYSTEMCONNECT);
        history.push(urlConstants.PAGE_FB_SEND_LIST)
      }
    })
  }

  const getSendList = () => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    fetchData(call.token);
  }

  //確認匯出報表
  const confirmReport = (sendList) => {
    setIsProcessing('downloadReport');

    if (entryPath === urlConstants.PAGE_FB_CREATE_DATA) {
      setCurrentActiveData(sendList[0]);
    }
    setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
    setModalData({ reportName });
    setIsModalOpen(true);
    setIsProcessing(false);
    setIsLoading(false);
  }

  //下載報表excel
  const downloadReport = () => {
    setIsProcessing('downloadReport');
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const reportMedia = getManualTranslation('common.title.facebookReport', reportLanguage);
    const fileName = `${reportMedia}${updatedReportName}_${dataRange}.xlsx`;

    apiList.downloadCustomReport({
      weeklyReportId: currentActiveData.weeklyReportId,
      start_date: formatDate2(reportDateRange.startReportDate),
      end_date: formatDate2(reportDateRange.endReportDate)
    })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            setIsModalOpen(false);
            setIsProcessing(false);
            history.push(urlConstants.PAGE_FB_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          alert(alertConstants.ERROR_SYSTEMCONNECT);
          history.push(urlConstants.PAGE_FB_SEND_LIST)
        }
      })
  }

  const downloadExternalReport = (updateReportData) => {
    setIsProcessing('downloadReport');
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const reportMedia = getManualTranslation('common.title.facebookReport', reportLanguage);
    const fileName = `${reportMedia}${updatedReportName}_${dataRange}.xlsx`;

    const params = {
      // requestKey: requestKey,
      // startDate: formatDate3(reportDateRange.startReportDate),
      // endDate: formatDate3(reportDateRange.endReportDate)
    }

    apiList.downloadExternaleport({ data: updateReportData, config: params })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setIsModalOpen(false);
          setTimeout(() => {
            setIsProcessing(false);
            history.push(urlConstants.PAGE_FB_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          handleAlertMsgSettings(true, { type: alertConstants.ALERT_TYPE.ERROR, msg: `${alertConstants.ERROR_SYSTEMCONNECT} ${res.status}` });
          history.push(urlConstants.PAGE_FB_SEND_LIST)
        }
      })
  }

  //2.updateReport
  const updateReport = (updateReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.updateReport({ data: updateReportData, config: { weeklyReportId: currentActiveData.weeklyReportId } })
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false);
          if (downloadOrSend === 'downloadData') {
            setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
            setModalData({ reportName });
            setIsModalOpen(true);

          } else if (downloadOrSend === 'sendData') {
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_FB_SEND_LIST);
            }, 2000)
          }

        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setIsLoading(false);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })
  }

  const handleModalSubmit = (data, type) => {
    switch (type) {
      case 'confirm_download_report':
        downloadReport();
        break;
      case 'download_report_no_data':
        setIsModalOpen(false);
        setEntryPath(urlConstants.PAGE_FB_EDIT_DATA);
        break;
      case 'check_import_customfields':
      case 'check_no_customfields':
      case 'check_import_marketing_campaign':
      case 'check_no_marketing_campaign':
        setIsModalOpen(false);
        break;
      default:
        break;
    }
  }

  // console.log('fields', _.concat(hideRequiredFields, selectedOptionFields));

  return (
    <>
      {
        userData.scopes.includes(basicConstants.AUTH_EDIT_REPORT) &&
        <>
          <Box
            id="scrollTop"
            sx={{
              width: { sm: '100%', md: '80%', lg: '70%' },
              margin: '0 auto 60px'
            }}
          >
            {
              cidList.length > 0 &&
              <>
                <FormTitle
                  media={"Facebook"}
                  currentTab={currentTab}
                  mainColor={mainColor}
                  setCurrentTab={setCurrentTab}
                />

                <Box sx={{ overflow: 'hidden' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      top: 0,
                      left: `-${currentTab * 100}%`,
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: '200%',
                      transition: 'left .5s'
                    }}
                  >
                    <Box id="basicData" sx={{ width: '100%', padding: '0 4px' }}>
                      <NameAndAccountData
                        media='Facebook'
                        cidList={cidList}
                        selectedAdAccounts={selectedAdAccounts}
                        setSelectedAdAccounts={setSelectedAdAccounts}
                        reportName={reportName}
                        setReportName={setReportName}
                        handleInput={handleInput}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <FbCampaignData
                        selectedAdAccounts={selectedAdAccounts}
                        campaignList={campaignList}
                        setCampaignList={setCampaignList}
                        selectedCampaign={selectedCampaign}
                        setSelectedCampaign={setSelectedCampaign}
                        fetchCampaignData={fetchCampaignData}
                        setModalName={setModalName}
                        setIsLoading={setIsLoading}
                        scrollToAnchor={scrollToAnchor}
                      />

                      <BasicData
                        media={media}
                        reportLanguage={reportLanguage}
                        setReportLanguage={setReportLanguage}
                      />

                      <ExcelData
                        media={media}
                        excelSheets={excelSheets}
                        excelSheetSelected={excelSheetSelected}
                        setExcelSheetSelected={setExcelSheetSelected}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                      />

                      <FbFieldsData
                        selectedAdAccounts={selectedAdAccounts}
                        requiredFields={requiredFields}
                        allOptionFields={allOptionFields}
                        setAllOptionFields={setAllOptionFields}
                        selectedOptionFields={selectedOptionFields}
                        setSelectedOptionFields={setSelectedOptionFields}
                        handleModalDetail={handleModalDetail}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                        setDownloadInputErrorMsg={setDownloadInputErrorMsg}
                        updateSortFields={updateSortFields}
                        setUpdateSortFields={setUpdateSortFields}
                        excelSheetSelected={excelSheetSelected}
                        reportLanguage={reportLanguage}
                      // origiCustomData={origiCustomData}
                      // setOrigiCustomData={setOrigiCustomData}
                      // selectedCustomFields={selectedCustomFields}
                      // setSelectedCustomFields={setSelectedCustomFields}
                      // setModalName={setModalName}
                      // setIsLoading={setIsLoading}
                      // scrollToAnchor={scrollToAnchor}
                      />

                      <ButtonReportData
                        id="scrollDown"
                        colorSystem={colorMedia}
                        clickDownloadReport={clickDownloadReport}
                        setCurrentTab={setCurrentTab}
                        scrollToAnchor={scrollToAnchor}
                      />

                    </Box>

                    <Box id="pagesAndFields" sx={{ width: '100%', padding: '0 4px' }}>
                      <SendTime
                        media={media}
                        sendTimeData={sendTimeData}
                        setSendTimeData={setSendTimeData}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <EmailData
                        media={media}
                        emailList={emailList}
                        setEmailList={setEmailList}
                        emailString={emailString}
                        setEmailString={setEmailString}
                        EmailTemplate={EmailTemplate}
                        emailTemplateCurrent={emailTemplateCurrent}
                        setEmailTemplateCurrent={setEmailTemplateCurrent}
                        emailTemplatePrev={emailTemplatePrev}
                        setEmailTemplatePrev={setEmailTemplatePrev}
                        emailTemplateType={emailTemplateType}
                        setEmailTemplateType={setEmailTemplateType}
                        inputErrorMsg={inputErrorMsg}
                        setInputErrorMsg={setInputErrorMsg}
                        handleInput={handleInput}
                        optionalFields={optionalFields}
                        requiredMetricsFields={requiredMetricsFields}
                      />

                      <ButtonSendData
                        colorSystem={colorMedia}
                        setCurrentTab={setCurrentTab}
                        clickUpdateReport={clickUpdateReport}
                        url={urlConstants.PAGE_FB_SEND_LIST}
                      />

                    </Box>

                  </Box>
                </Box>
              </>
            }
          </Box>
          {
            cidList.length === 0 && !isLoading &&
            <NoAdAccountPage
              colorSystem={colorMedia}
              setEntryPath={setEntryPath}
            />
          }
          {
            modalName === 'alert' &&
            <Modal open={modalName === 'alert'} >
              <BoxModalAlert>
                <Typography textAlign="center"><FormattedMessage id="createData.modal.saveReport" /></Typography>
                <Typography textAlign="center" sx={{ color: mainColor }}>{reportName}</Typography>
              </BoxModalAlert>
            </Modal>
          }
          {
            modalName === 'create_custom_metric' &&
            <CreateFields
              media='FACEBOOK'
              optionalFields={requiredMetricsFields.concat(allOptionFields)}
              open={modalName === 'create_custom_metric'}
              handleClose={() => setModalName(false)}
              handleSave={addCustomFields}
              reportLanguage={reportLanguage}
            />
          }
          {/* 自訂走期下載報表 */}
          {
            modalName === 'setting_report_dateRange' &&
            <DownloadReportModal
              media={media}
              open={modalName === 'setting_report_dateRange'}
              reportDateRange={reportDateRange}
              setReportDateRange={setReportDateRange}
              inputErrorMsg={inputErrorMsg}
              isLoading={isProcessing}
              handleClose={() => setModalName(false)}
              handleChooseSaveReport={handleChooseSaveReport}
            />
          }
          <ModalComponent
            isLoading={isProcessing}
            handleModalSubmit={handleModalSubmit}
          />
        </>
      }
      <Loading isLoading={isLoading} content={alertConstants.TIP_DATA_LOADING} />
    </>
  )
}

export default FbCreateData;